

define(['squid/index', 'text!./template.html'], function (squid, template, opinionlab) {
  squid.module('xo-login-button.directive', ['squid']).directive('xoLoginButton', [function () {
    return {
      template: template,
      scope: {
        redirect: '=?'
      },
      controller: ['$scope', function ($scope) {}]
    };
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/login-button/directive.js
// module id = ../node_modules/xo-guest-components/src/login-button/directive.js
// module chunks = 0